const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="o-container o-container--pad o-container--prose">
  <div class="o-container__content o-rhythm o-rhythm--generous-headings">
    `);
                if ((context.has(`show_example_content`) ? context.get(`show_example_content`) : null)) {
                    this.echo(`      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vestibulum ut erat at suscipit. Aliquam viverra velit quam, sed condimentum ante posuere quis.</p>
      <h2>Example Heading</h2>
      <p>Morbi iaculis nisi at dolor pharetra, ut tempus purus porta. Sed condimentum est eu orci hendrerit suscipit. Vestibulum nec ex nisi.</p>
    `);
                }
                this.echo(`    <div id="mc_embed_shell">
      <div id="mc_embed_signup">
        <form
          action="#"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          class="validate"
          target="_self"
          novalidate=""
        >
          <div id="mc_embed_signup_scroll">
            `);
                if ((context.has(`transform_heading`) ? context.get(`transform_heading`) : null)) {
                    this.echo(`              `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`content`, `Download the checklist and get Cloud Four in your inbox`], [`level`, 2], [`permalink`, true], [`id`, `mailchimp-heading`]]), false, false, 21));
                    this.echo(`            `);
                }
                else {
                    this.echo(`              <h2>Download the checklist and get Cloud Four in your inbox</h2>
            `);
                }
                this.echo(`
            <div class="indicates-required">
              <span class="asterisk">*</span> indicates required
            </div>
            <div class="mc-field-group">
              <label for="mce-EMAIL"
                >Email Address <span class="asterisk">*</span></label
              ><input
                type="email"
                name="EMAIL"
                class="required email"
                id="mce-EMAIL"
                required=""
                value=""
              />
            </div>
            <div hidden="">
              <input type="hidden" name="tags" value="EXAMPLE" />
            </div>
            <div id="mce-responses" class="clear">
              <div
                class="response"
                id="mce-error-response"
                style="display: none"
              ></div>
              <div
                class="response"
                id="mce-success-response"
                style="display: none"
              ></div>
            </div>
            <div aria-hidden="true" style="position: absolute; left: -5000px">
              <input type="text" name="EXAMPLE" tabindex="-1" value="" />
            </div>
            <div class="clear">
              <input
                type="submit"
                name="subscribe"
                id="mc-embedded-subscribe"
                class="button"
                value="Subscribe"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `acd1b55fc07115199921aaa84427312e84c6710a0dcb5ff5f8600fe188e4fd5f`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `acd1b55fc07115199921aaa84427312e84c6710a0dcb5ff5f8600fe188e4fd5f`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'acd1b55fc07115199921aaa84427312e84c6710a0dcb5ff5f8600fe188e4fd5f');

let template = env.loadTemplate('acd1b55fc07115199921aaa84427312e84c6710a0dcb5ff5f8600fe188e4fd5f');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/mailchimp/demo/signup.twig", args: context }
     );
     return rendered;;
};